import {BACKEND_ENDPOINT} from '../../../Constants'
import axiosInstance from '../../../config/AxiosConfig'

export function createExportLog(userId, data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/log/createExportLog`, data, {
            params: {userId},
        })
        .then(res => res.data)
        .catch(error => error)
}
